export const deviceWithMFC = "MFC"
export const deviceWithDCP = "DCP"
export const deviceWithHL = "HL"